import { render, staticRenderFns } from "./CCRISitems.vue?vue&type=template&id=da65b86a"
import script from "./CCRISitems.vue?vue&type=script&lang=js"
export * from "./CCRISitems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports